import {
  CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED,
  DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED,
  SET_EVENT_PRICE_DETAILS_DATA_SHARED
} from './constants';

const initialState = {
  showEventPriceDetailsModal: false,
  eventPriceDetailsData: {}
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED:
      return {
        ...state,
        showEventPriceDetailsModal: false
      };
    case DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED:
      return {
        ...state,
        showEventPriceDetailsModal: true
      };
    case SET_EVENT_PRICE_DETAILS_DATA_SHARED:
      return {
        ...state,
        eventPriceDetailsData: payload
    };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/shared/eventPriceDetailsModal/reducer.js